'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../../_tslib-15827112.js');
var BaseController = require('../BaseController.js');

var BalanceController = /** @class */ (function (_super) {
    _tslib.__extends(BalanceController, _super);
    function BalanceController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.basePath = "/Balance";
        return _this;
    }
    BalanceController.prototype.Get = function () {
        var endpoint = this.basePath + "/" + this.config.countryCode;
        return this.MakeRequest({
            url: endpoint,
        });
    };
    return BalanceController;
}(BaseController.default));

exports.default = BalanceController;
//# sourceMappingURL=BalanceController.js.map
